import { Button, Theme, Typography, WithStyles, createStyles, withStyles } from "@material-ui/core";
import { IStoreState, ThunkDispatch } from "../../../modules";
import React, { Fragment } from "react";

import GenericEnroll from "./GenericEnroll";
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getEnrolledTrxSign } from "../../../modules/authmethods";

const styles = (theme: Theme) => createStyles({

})

type TrxSignEnrollState = {
}

class TrxSignEnroll extends React.Component<Props, TrxSignEnrollState> {
  static propTypes = {
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired
  }

  state = {
  }

  componentDidMount = () => {
    this.reloadEnrolment()
  }

  reloadEnrolment = () => {
    this.props.getEnrolledTrxSign().then((_: any) => {
      let enrolled = this.props.authmethods.trxSign.enrolled

      this.setState({
        enrolled,
      })
    })
  }

  renderForm = () => {
    const { authmethods } = this.props
    return <Fragment>
      {
        !authmethods.trxSign.enrolled
          ? <Fragment>
            <Typography variant="body1">Enroll for transaction signing from the mobile app</Typography>
            <Button variant="contained" color="primary" onClick={this.reloadEnrolment}>Check for Enrolment</Button>
          </Fragment>
          : <Fragment>
            <Typography variant="body1">Transaction signing enrolled</Typography>
          </Fragment>
      }
    </Fragment>
  }

  render = () => {
    return <GenericEnroll
      authMethodName="Transaction Signing"
      enrolled={this.props.authmethods.trxSign.enrolled}
      renderForm={this.renderForm}
      expanded={this.props.expanded}
      setExpanded={this.props.setExpanded}
      error=""
      dirty={false} />
  }
}

const mapStateToProps = ({ accounts, authmethods, intl }: IStoreState) => ({
  accounts,
  authmethods,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      getEnrolledTrxSign,
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  expandNext: () => void
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TrxSignEnroll))